<template>
  <form class="form-horizontal" v-if="campaign">
    <div class="row">
      <div class="form-group col-md-6">
        <CampaignName :campaign="campaign" />
      </div>
      <div class="form-group col-md-3">
        <StatusDropdown :campaign="campaign" @updated="$emit('updated')" />
      </div>
    </div>
    <hr />

    <div class="row">
      <CampaignDuration :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <BackgroundImage :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <PrizeAllPicture :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <TextArea :campaign="campaign" />
    </div>
    <div class="row">
      <PeriodDuration :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <TargetAndRewardValues :campaign="campaign" @updated="$emit('updated')" />
    </div>
    <hr />
    <div class="row">
      <ProgressUpload :campaign="campaign" @updated="$emit('updated')" />
    </div>
  </form>
</template>

<script>
import TextArea from "./components/TextArea.vue";
import PeriodDuration from "./components/PeriodDuration.vue";
import ProgressUpload from "./components/ProgressUpload.vue";
import StatusDropdown from "./components/StatusDropdown.vue";
import PrizeAllPicture from "./components/PrizeAllPicture.vue";
import BackgroundImage from "./components/BackgroundImage.vue";
import CampaignDuration from "./components/CampaignDuration.vue";
import CampaignName from "@/views/progressbar/components/CampaignName.vue";
import TargetAndRewardValues from "./components/TargetAndRewardValues.vue";

export default {
  name: "WeeklyForm",

  props: ["campaign"],

  components: {
    TextArea,
    CampaignName,
    PeriodDuration,
    ProgressUpload,
    StatusDropdown,
    PrizeAllPicture,
    BackgroundImage,
    CampaignDuration,
    TargetAndRewardValues,
  },
};
</script>
